export class ProspectoAnexosApi {
    async index() {
        try {
            const response = await axios.get('/adm/prospectos/tipos-anexos');

            return response.data;
        } catch (error) {
            console.error('Error fetching tipos anexos:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/Prospecto/ProspectoAnexoApi.js